
<div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="Refugee Verification" />

    <div>
        <div class="d-flex justify-content-center align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="d-flex align-items-center">
            <span><i class="text-muted bi bi-question-circle me-2"></i></span>
            <span class="text-muted text-xs">
                The refugee verification process validates asylum seeker information against official records,
                ensuring accuracy and compliance with immigration databases.
            </span> 
            </div> 
            <div class="form-group mt-3">
            <label for="refugee_number" class="form-label fw-bold text-xxs">
                Refugee Number <span class="text-danger fw-bold">*</span>
            </label>
            <input 
                id="refugee_number" 
                type="text"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                :value="refugee_number"
                placeholder="Enter Refugee Number"
                maxlength="15"
                @input="allow_alphanumeric"
                :disabled="is_field_disabled.refugee_number">
            <div class="mt-3 d-flex flex-column text-center col-12 col-md-9 col-lg-8 mx-auto">
                <small class="text-danger fw-bold text-xs d-none refugee-message">
                Please fill in this field
                </small>
                <small class="text-danger fw-bold text-xs d-none invalid-message">
                Please enter a valid refugee number
                </small>
            </div>
            </div>
        </div>
        </div>
        
        <div class="text-center">
        <button
            type="button"
            class="btn bg-green btn-sm mt-1 rounded-small shadow-sm fw-bold secondary-text-dark text-xs"
            @click="verify_refugee"
        >
            Verify
        </button>
        </div>
    </div>
</div>

